import type { PopoverProps } from '@nuxt/ui';
import type { ComputedRef, VNode } from 'vue';
import { createContext } from 'reka-ui';

export interface HoverCardRequest {
	reference: HTMLElement;
	renderContent: () => VNode[] | undefined;
	content?: PopoverProps['content'];
	contentClass?: string;
}

/** What a trigger may do with the shared card. */
export interface HoverCardController {
	/** The trigger whose card is currently open. */
	openReference: ComputedRef<HTMLElement | undefined>;
	show: (request: HoverCardRequest) => void;
	/** Closes after a short grace period if `reference` still owns the card, so the pointer can cross onto it. */
	hide: (reference: HTMLElement) => void;
	/** Closes immediately if `reference` owns the card; for triggers that unmount while showing it. */
	release: (reference: HTMLElement) => void;
}

/** What `DHoverCardOutlet` needs to render the shared card. */
export interface HoverCardOutletContext {
	active: ComputedRef<HoverCardRequest | undefined>;
	open: ComputedRef<boolean>;
	openReference: ComputedRef<HTMLElement | undefined>;
	/** The pointer is over the card. */
	keepOpen: () => void;
	/** The pointer left the card. */
	closeSoon: () => void;
	close: () => void;
}

export const [injectHoverCardController, provideHoverCardController] = createContext<HoverCardController>('DHoverCardProvider');
export const [injectHoverCardOutletContext, provideHoverCardOutletContext] = createContext<HoverCardOutletContext>('DHoverCardProvider');
